var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content main-crm-content" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "container new-list" },
      _vm._l(_vm.newList, function(item, key) {
        return _c("div", { key: key, staticClass: "item" }, [
          _c("p", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
          _c("img", { attrs: { src: item.icon, alt: "" } }),
          _c("p", { staticClass: "con" }, [_vm._v(_vm._s(item.value))])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container content-title" }, [
      _c("img", {
        staticClass: "img-box",
        attrs: { src: require("static/images/trait/wms.png"), alt: "oa" }
      }),
      _c("h3", { staticClass: "services-title1" }, [_vm._v("仓库管理系统")]),
      _c("p", { staticClass: "container-sub-title sub-title" }, [
        _vm._v(
          "易安捷WMS是自主研发的一款仓储精细化管理软件，支持多仓库、库位一绑多，支持人找货、货到人等作业模式，可实现物动账动， 库存流向精细查询。系统以商品能力和订单能力作为数据流动的基础，并且结合手机APP快速拣货、验货、打印快递面单等功能。"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-587f6531", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-587f6531","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/wms/Content.vue
// module id = POf1
// module chunks = 9